import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=5b097242&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b097242')) {
      api.createRecord('5b097242', component.options)
    } else {
      api.reload('5b097242', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=5b097242&", function () {
      api.rerender('5b097242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26GQ6lqh8qp9c/JS/priceformat.vue"
export default component.exports